var React = require('react');

function ArrowBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z","fill":"#fff"}));
}

ArrowBack.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowBack;

ArrowBack.default = ArrowBack;
